import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Timeline } from "../../components/Timeline";
import { Facebook } from "./Facebook";
import { Instagram } from "./Instagram";
import { Overview } from "./Overview";
import { Campaigns } from "./Campaigns";
import { SMS } from "./SMS";
import { Whatsapp } from "./Whatsapp";
import { FacebookADS } from "./FacebookAds";

export function Dashboard() {
  const tabs = [
    {
      label: "Visão geral",
      index: 0,
      children: <Overview />,
    },
    {
      label: "Facebook",
      index: 1,
      children: <Facebook />,
    },
    {
      label: "Instagram",
      index: 2,
      children: <Instagram />,
    },
    {
      label: "Impulsionamento",
      index: 3,
      children: <FacebookADS />,
    },
    {
      label: "Whatsapp",
      index: 4,
      children: <Whatsapp />,
    },
    {
      label: "SMS",
      index: 5,
      children: <SMS />,
    },
  ];

  return (
    <Stack
      direction="row"
      divider={<Divider orientation="vertical" flexItem />}
    >
      <Stack spacing={1} width="70%">
        <Typography variant="h6">Resultados</Typography>
        <Typography variant="body2">
          Veja a performance das suas campanhas.
        </Typography>

        <Timeline tabs={tabs} padding="36px 0 0 0" />
      </Stack>
      <Campaigns />
    </Stack>
  );
}
